import { GenericResponseModel } from "../dataModel/authModels";
import { InboxRequestObj } from "../dataModel/messagesModal";
import { ApiRoutes } from "./apiConfig/apiEdndpoints";
import { customAxios } from "./apiConfig/useExPressApi";
import FormData from "form-data";

export const messages = {

  getMessageList: async (data: InboxRequestObj) => {
    return customAxios.post(`${ApiRoutes.GET_MESSAGE_LIST}`, data);
  },

  insertMessage: async (data: any) => {
    const formData = new FormData();
    data?.messageAttachments?.forEach((file: File) => {
      formData.append('messageAttachments', file);
    });
    formData.append('subject', data.subject || '');
    formData.append('body', data.body || '');
    formData.append('htmlBody', data.htmlBody || '');
    formData.append('toStaffIds', data.toStaffIds || '');

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    return customAxios.post(`${ApiRoutes.INSERT_MESSAGE}`, formData, config);
  },
  getClientAssignedStaffDDL: (isActive: boolean) => {
    return customAxios.get<any, GenericResponseModel>(`${ApiRoutes.GET_CLIENT_ASSIGNED_STAFFS_DDL}`, {
      params: { isActive }
    });
  },

  deleteMessage: async (ApiData: any) => {
    return  customAxios.delete(ApiRoutes.DELETE_MESSAGE, { data: ApiData }); 
  },

  getAttachment: async (attachmentId: any) => {
    return  customAxios.get(`${ApiRoutes.GET_CLIENT_ATTACHMENTS}${attachmentId}`); 
  },

  getUnreadMessageCount: async () => {
    return  customAxios.get(`${ApiRoutes.GET_UNREAD_MESSAGE_COUNT}`); 
  },

  markMessageRead: async (messageData:any) => {
    return  customAxios.post(`${ApiRoutes.MARK_MESSAGE_READ}`,messageData); 
  },
}